import React from 'react';
import { pasos } from '../data/planes';
export function ComoFunciona() {
  return <section aria-labelledby="como-funciona-titulo" className="w-full bg-surface px-6 py-20" data-id="element-64" data-mp="2cd3mgh9v5xr6">
      <div className="mx-auto max-w-content text-center" data-id="element-65" data-mp="2hcpy4ma1n5xv">
        <h2 id="como-funciona-titulo" className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-66" data-mp="2hd83c8eoouhx">
          ¿Cómo funciona?
        </h2>
        <p className="mt-4 text-muted" data-id="element-67" data-mp="1oo17jh6m6j0d">Simple, inmediato y desde cualquier país de LATAM</p>

        <ol className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-68" data-mp="1tmvpkgwrc3jf">
          {pasos.map(paso => <li key={paso.numero} className="rounded-3xl border border-edge bg-canvas p-8 text-left" data-id="element-69" data-mp="1ylys9up9lxo8">
              <div className="flex items-center gap-3" data-id="element-70" data-mp="23coyfa5im4jz">
                <span className="text-2xl" aria-hidden="true" data-id="element-71" data-mp="23e8d4wbiw7jn">
                  {paso.icono}
                </span>
                <span className="font-display text-2xl font-bold text-brand-300" data-id="element-72" data-mp="15v71jcqyy18a">{paso.numero}</span>
              </div>
              <h3 className="mt-4 font-display text-xl font-bold text-ink" data-id="element-73" data-mp="39whlucj36878">{paso.titulo}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-74" data-mp="39ybwmy0n8jxl">{paso.descripcion}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}